import CanvaImport from '@core/lib/admin/components/canva_import'
import PropTypes from 'prop-types'
import React from 'react'

class CanvaImportWrapper extends React.Component {

  static propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return <CanvaImport { ...this._getCanvaImport() } />
  }
  
  _getCanvaImport() {
    const { onBack } = this.props
    return {
      onBack,
      onDone: this._handleDone
    }
  }

  _handleDone(canva_import) {
    const { assets, design, profile } = canva_import
    this.props.onNext({
      profile_id: profile.id,
      title: design.name,
      view_url: design.view_url.split('?')[0],
      thumbnails: assets.map(asset => ({ 
        asset_id: asset.id,
        transforms: {
          crop: {
            l: 0,
            t: 0,
            w: asset.metadata.width,
            h: asset.metadata.height
          }
        }
      }))  
    })
  }

}

export default CanvaImportWrapper

